import styled from 'styled-components';

export const Icon = styled.span`
  margin: 0;
  font-size: ${(p) => p.size || '0.9em'};
  line-height: 120%;
  color: ${(p) => p.color};

  :before {
    color: ${(p) => p.color};
  }
`;

export const StatusIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.status[[p.status]]};
`;

export const StatusWidgetIcon = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(p) => p.color};
`;

export const RfidStatusIcon = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${(p) => p.theme.colors.rfid[p.status]};
`;

export const PurpleText = styled.div`
  height: 100%;
  color: ${(p) => p.theme.colors.accent.primary};
  font-weight: 700;
  text-decoration: underline;
  font-size: ${(p) => (p.mapStyle ? '20px' : '0.9em')};
  line-height: normal;
  cursor: ${(p) => p.selectable && 'pointer'};
  cursor: ${(p) => p.disabled && 'not-allowed'};
  white-space: ${(p) => p.hasWrap && 'initial'};
  margin-bottom: ${(p) => p.mapStyle && '10px'};
`;

export const GreyText = styled.div`
  text-align: ${({ textAlign }) => textAlign ?? 'unset'};
  height: 100%;
  color: ${(p) => p.theme.colors.primary.textGrey};
  font-size: 1em;
  line-height: normal;
  white-space: ${(p) => p?.wrap && 'initial'};
`;

export const GreyTextWrap = styled(GreyText)`
  white-space: noWrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BlackText = styled.div`
  color: ${(p) => p.theme.colors.primary.textDarkGrey};
  font-weight: ${(p) => p?.weight ?? 500};
  font-size: ${(p) => p?.size || '0.9em'};
  line-height: 120%;
`;

export const Horizontal = styled.div`
  display: flex;
  align-items: ${(p) => p?.align || 'center'};
  gap: 8px;
  justify-content: ${(p) => p?.justify || 'flex-start'};
  font-size: ${(p) => p?.fontSize || '1em'};
`;

export const Vertical = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ gap }) => gap ?? '0'};
`;

export const FooterText = styled.div`
  color: ${(p) => p.theme.colors.primary.textDarkGrey};
  font-weight: 700;
  font-size: 1em;
  line-height: 120%;
`;

export const CellLabelGray = styled.span`
  color: ${(p) => p.theme.colors.primary.textGrey};
  font-size: 0.8em;
  line-height: 120%;
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 16px auto;
  height: 2px;
  border-radius: 2px;
  background-color: ${(p) => p.theme.colors.primary.lightGrey};
`;

export const SmartButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5em;
`;

const TEXT_COLOR_MAPPER = (p) => {
  if (p.lightpurple) return p.theme.colors.accent.primary;
  if (p.purple) return p.theme.colors.accent.primary;
  return p.theme.colors.primary.textGrey;
};

export const Text = styled.div`
  color: ${(p) => TEXT_COLOR_MAPPER(p)};
  font-size: 0.8em;
  margin: 0;
  text-decoration: ${(p) => p?.lightpurple && 'underline'};
  font-weight: ${(p) => p?.lightpurple && 'bold'};
  font-weight: ${(p) => p?.purple && '600'};
`;

export const CarIcon = styled.div`
  margin: 5px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-image: ${(p) => `url(${p?.img})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  box-shadow: 2px 3px 8px 0 ${(p) => p.theme.colors.primary.whiteBoxShadow};
  border: solid 2px ${(p) => p?.borderColor ?? p.theme.colors.primary.lightGrey};
`;

export const ModalTitle = styled.p`
  font-size: 21px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: unset;
  line-height: 1.62;
  text-align: unset;
  text-transform: unset;
`;

export const ModalText = styled.p`
  color: ${(p) => p.theme.colors.primary.textGrey};
  font-size: 1em;
  line-height: 120%;
`;

export const SpanError = styled.span`
  color: red;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 400;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
